var map = {
	"./amakids.png": 17803,
	"./amakids_ru.png": 27899,
	"./markets/app-store.png": 42340,
	"./markets/google-play.png": 3553,
	"./markets/windows.png": 79830,
	"./smartum.png": 54898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98359;